import { useState } from 'react';
import BaseSlideout from '../slideout';
import Button, { ButtonType, ButtonState } from '../../button/Button';
import Icon, { IconType } from '../../icon/Icon';

import './sortingMobilePanel.scss';

type SortingOptionItem = {
  value: string;
  label: string;
};

type SortingSlideoutProps = {
  isVisible: boolean;
  onClose: () => void;
  sortingOptions: SortingOptionItem[];
  activeOption: string;
  onApply: (selectedOption: string) => void;
  onClear: () => void;
};

const SortingSlideout = ({
  isVisible,
  onClose,
  sortingOptions,
  activeOption,
  onApply,
  onClear,
}: SortingSlideoutProps) => {
  const [selectedOption, setSelectedOption] = useState(activeOption);

  const handleApply = () => {
    onApply(selectedOption);
    onClose();
  };

  const handleClear = () => {
    setSelectedOption('');
    onClear();
  };

  return (
    <BaseSlideout
      isVisible={isVisible}
      onClose={onClose}
      title="Sort By"
      className="sorting-slideout filter-slideout"
    >
      <hr className="divider" />
      <div className="slideout-body filter-slideout-body">
        <div className="scrollable-content">
          {sortingOptions.map((option, index) => (
            <div key={option.value}>
              <div
                className={`sorting-option ${
                  option.value === selectedOption ? 'active' : ''
                }`}
                onClick={() => setSelectedOption(option.value)}
              >
                <div className="icon-cell">
                  {option.value === selectedOption && (
                    <Icon
                      iconType={IconType.Available}
                      className="u-icon-small u-fill-active"
                    />
                  )}
                </div>
                <div className="label-cell">{option.label}</div>
              </div>

              {<hr className="divider" />}
            </div>
          ))}
        </div>
      </div>

      <div className="slideout-footer">
        <hr className="divider" />
        <div className="buttons filter-buttons">
          <Button
            type={ButtonType.TERTIARY}
            state={ButtonState.DEFAULT}
            extraClasses="filter-button"
            onClick={handleClear}
            label="Cancel"
          />
          <Button
            type={ButtonType.SECONDARY}
            state={ButtonState.DEFAULT}
            extraClasses="filter-button"
            onClick={handleApply}
            label="View"
          />
        </div>
      </div>
    </BaseSlideout>
  );
};

export default SortingSlideout;
